import type { HexColor } from '@/shared/schemas/color'
import type { AnyExtension } from '@tiptap/core'

import StarterKit from '@tiptap/starter-kit'
import { ImageNode } from '../cell/content/tiptap/image/ImageNode'

export const MENTIONS_EDITOR_EXTENSIONS = [
  StarterKit.configure({
    heading: false,
    codeBlock: false,
    blockquote: false,
    horizontalRule: false,
  }),
  // Custom nodes (Only Image allowed)
  ImageNode,
] as const satisfies AnyExtension[]

export const MENTIONS_COLOR_PALETTE = [
  // https://coolors.co/palette/264653-2a9d8f-e9c46a-f4a261-e76f51
  '#264653',
  '#2a9d8f',
  '#e9c46a',
  '#f4a261',
  '#e76f51',
  // https://coolors.co/palette/ff99c8-fcf6bd-d0f4de-a9def9-e4c1f9
  '#ff99c8',
  '#fcf6bd',
  '#d0f4de',
  '#a9def9',
  '#e4c1f9',
  // https://coolors.co/palette/8cb369-f4e285-f4a259-5b8e7d-bc4b51
  '#8CB369',
  '#F4E285',
  '#F4A259',
  '#5B8E7D',
  '#BC4B51',
  // https://coolors.co/palette/ffcdb2-ffb4a2-e5989b-b5838d-6d6875
  '#FFCDB2',
  '#FFB4A2',
  '#E5989B',
  '#B5838D',
  '#6D6875',
  // https://coolors.co/palette/5f0f40-9a031e-fb8b24-e36414-0f4c5c
  '#5F0F40',
  '#9A031E',
  '#FB8B24',
  '#E36414',
  '#0F4C5C',
  // https://coolors.co/palette/606c38-283618-fefae0-dda15e-bc6c25
  '#606C38',
  '#283618',
  '#FEFAE0',
  '#DDA15E',
  '#BC6C25',
] as const satisfies HexColor[]
